import React, { Component, Fragment } from "react";
import queryString from "query-string";
import moment from "moment";

import api from "services/api";

import {
  Page,
  Panel,
  Breadcrumbs,
  Pagination,
  Loading,
} from "components";

import { Log, Filters } from "./components";

class Messages extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Configurações", to: "/configs" },
      { name: "Log", to: "" },
    ],
    filter: {
      date_start: new Date(),
      date_end: null,
      auditable_type: null,
    },
    selection: [],
    logs: [],
    loading: true,
    page: 1,
    total: 0,
  };

  componentDidMount() {
    const { filter } = this.state;
    const { location } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    this.loadData(page, filter);
  }

  componentDidUpdate(oldProps) {
    const { filter } = this.state;
    const { location } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      this.loadData(queryString.parse(location.search).page, filter);
    }
  }

  loadData = async (page = 1, filter) => {
    try {
      this.setState({ loading: true });
      const response = await api.get("settings/v2/audits", {
        params: {
          page,
          per: 25,
          auditable_id: filter.id !== ''
            ? filter.id
            : null,
          start_date:
            filter.date_start !== null
              ? `&date_start=${moment(filter.date_start).format("YYYY-MM-DD")}`
              : null,
          end_date:
            filter.date_end !== null
              ? `&date_end=${moment(filter.date_end).format("YYYY-MM-DD")}`
              : null,
          auditable_type:
            filter.auditable_type !== null ? filter.auditable_type.value : null,
        },
      });
      const { data, meta } = response.data;


      this.setState({ logs: data, page: meta.current_page, total: meta.total_count });
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    await this.setState({ filter: { ...filter, [name]: value } });
    this.loadData(1, this.state.filter);
  };

  handleClean = async (e) => {
    e.preventDefault();

    await this.setState({
      filter: {
        date_start: null,
        date_end: null,
        auditable_type: null,
      },
    });
    this.loadData(1, this.state.filter);
  };

  render() {
    const { breadcrumbs, filter, logs, loading, page, total } = this.state;

    return (
      <Page className="page-logs">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="message-header">
          <Page.Title>Log</Page.Title>
        </header>

        <Filters
          data={filter}
          onChange={this.handleChangeFilter}
          onClean={this.handleClean}
        />

        <Panel className="panel-list">
          {!logs.length && loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>tipo</th>
                    <th>ação</th>
                    <th>versão</th>
                    <th>usuário</th>
                    <th>ip</th>
                    <th>data</th>
                    <th>ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!logs.length && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {logs.map((log, index) => (
                    <Log data={log} key={`log-${String(index)}`} />
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="8" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={page}
                total={total}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

export default Messages;
